module.exports = __webpack_public_path__ + "img/list_Character_sq_20.5a0f8836.jpeg";